/* PAPETERIE MONTPARNASSE — Accueil : hero slideshow (DEV, reversible).
   Custom element autonome. Autoplay doux + fondu (CSS), pause survol/focus,
   fleches + pastilles, balayage tactile (mobile), respect de prefers-reduced-motion. */
(function () {
  if (customElements.get('pm-hero-slideshow')) { return; }

  class PMHeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.pm-hero__slide'));
      if (this.slides.length < 2) { return; }
      this.dots = Array.prototype.slice.call(this.querySelectorAll('.pm-hero__dot'));
      this.i = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.canAuto = this.dataset.autoplay === 'true' && !this.reduce;
      this.delay = parseInt(this.dataset.interval, 10) || 6000;
      var self = this;
      var prev = this.querySelector('.pm-hero__arrow--prev');
      var next = this.querySelector('.pm-hero__arrow--next');
      if (prev) { prev.addEventListener('click', function () { self.go(self.i - 1); }); }
      if (next) { next.addEventListener('click', function () { self.go(self.i + 1); }); }
      this.dots.forEach(function (d, k) { d.addEventListener('click', function () { self.go(k); }); });
      this.addEventListener('mouseenter', function () { self.stop(); });
      this.addEventListener('mouseleave', function () { self.start(); });
      this.addEventListener('focusin', function () { self.stop(); });
      this.addEventListener('focusout', function () { self.start(); });

      // Balayage tactile (mobile) : swipe horizontal -> slide precedente / suivante.
      // Scroll vertical laisse libre ; on ne capte que les gestes nettement horizontaux.
      var frame = this.querySelector('.pm-hero__frame');
      if (frame) { frame.style.touchAction = 'pan-y'; }
      var tx = 0, ty = 0, tActive = false;
      this.addEventListener('touchstart', function (e) {
        if (!e.changedTouches || !e.changedTouches.length) { return; }
        tx = e.changedTouches[0].clientX;
        ty = e.changedTouches[0].clientY;
        tActive = true;
        self._swiped = false;
        self.stop();
      }, { passive: true });
      this.addEventListener('touchend', function (e) {
        if (!tActive || !e.changedTouches || !e.changedTouches.length) { self.start(); return; }
        tActive = false;
        var dx = e.changedTouches[0].clientX - tx;
        var dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          self._swiped = true;
          setTimeout(function () { self._swiped = false; }, 400);
          if (dx < 0) { self.go(self.i + 1); } else { self.go(self.i - 1); }
        } else {
          self.start();
        }
      }, { passive: true });
      this.addEventListener('touchcancel', function () { tActive = false; self.start(); }, { passive: true });
      // Empeche le lien plein-cadre de naviguer si le geste etait un balayage.
      this.addEventListener('click', function (e) {
        if (self._swiped) { e.preventDefault(); e.stopPropagation(); self._swiped = false; }
      }, true);

      this.start();
    }
    disconnectedCallback() { this.stop(); }
    show(n) {
      this.slides[this.i].classList.remove('is-on');
      this.slides[this.i].setAttribute('aria-hidden', 'true');
      if (this.dots[this.i]) { this.dots[this.i].classList.remove('is-on'); }
      this.i = (n + this.slides.length) % this.slides.length;
      this.slides[this.i].classList.add('is-on');
      this.slides[this.i].removeAttribute('aria-hidden');
      if (this.dots[this.i]) { this.dots[this.i].classList.add('is-on'); }
    }
    go(n) { this.show(n); this.start(); }
    start() { this.stop(); if (this.canAuto) { var self = this; this.timer = setInterval(function () { self.show(self.i + 1); }, this.delay); } }
    stop() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
  }

  customElements.define('pm-hero-slideshow', PMHeroSlideshow);
})();
